import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Breadcrumb } from 'primeng/breadcrumb';
import { MenuItem, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  FormsModule,
  Validators,
} from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteUtils } from '@app/core/utils/route.util';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { UserService } from '@app/auth/services/user.service';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { forkJoin, of, catchError } from 'rxjs';
import { ConfiguracoesService } from '@app/shared/components/api/services/configuracoes.service';
import { CheckboxModule } from 'primeng/checkbox';
import { TruncateTextComponent } from '@app/shared/components/truncate-text/truncate-text.component';
import { AuthService } from '@app/auth/services/auth.service';
import { AuthRedirectService } from '@app/auth/services/auth-redirect.service';
import { getResponseMessage } from '@app/shared/utils/response-message.util';

@Component({
  selector: 'app-detalhe-pagamento',
  imports: [
    TruncateTextComponent,
    Breadcrumb,
    CommonModule,
    InputNumberModule,
    FormsModule,
    ReactiveFormsModule,
    MoneyPipe,
    CheckboxModule,
  ],
  providers: [
    CampanhaService,
    AnexoFicheiroService,
    UtilizadoresService,
    ApoioService,
    UserService,
    EnumService,
    ConfiguracoesService,
    AuthService,
  ],
  standalone: true,
  templateUrl: './detalhe-pagamento.component.html',
  styleUrl: './detalhe-pagamento.component.scss',
})
export class DetalhePagamentoComponent implements OnInit {
  items: MenuItem[] = [];
  home: MenuItem | undefined;
  private readonly messageService = inject(MessageService);
  private readonly ativateRouder = inject(ActivatedRoute);
  private readonly campanhaService = inject(CampanhaService);
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly apoioService = inject(ApoioService);
  private readonly userService = inject(UserService);
  private readonly enumService = inject(EnumService);
  private readonly configuracoesService = inject(ConfiguracoesService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);
  private readonly authRedirectService = inject(AuthRedirectService);
  campanha: any;
  campanhaID: any;
  form!: FormGroup;
  totalDoar: number = 0;
  loading = false;
  resposta: any;
  btn_disabled = false;
  IsprofileComplet: boolean = false;
  utilizador: any;
  imgInfo?: { nome: string; tamanho: string; tipo: string };
  imgPreview?: string;
  showReferencePayment: number = 0;
  metodoPaymentList: any;
  metodo: any;
  IsrecompensaCampanha: boolean = false;
  apoiarSemRecompensa: boolean = false;
  useSaldoUser: boolean = false;
  showResposta: boolean = false;
  recompensaSelecionada: any = null;
  valorMax: number = 0;
  valorMin: number = 0;
  taxaServico: number = 0;
  saldo: any;
  IsAuthenticad: boolean = true;
  tipoFinanciamento: number = 0;
  readonly moneyPipe = new MoneyPipe();

  parseMonetaryValue(val: any): number {
    if (val === null || val === undefined || val === '') return 0;
    if (typeof val === 'number') return isNaN(val) ? 0 : val;
    if (typeof val === 'string') {
      let clean = val.replace(/[^0-9,.-]/g, '').trim();
      if (!clean) return 0;
      if (clean.includes('.') && clean.includes(',')) {
        if (clean.lastIndexOf(',') > clean.lastIndexOf('.')) {
          clean = clean.replace(/\./g, '').replace(',', '.');
        } else {
          clean = clean.replace(/,/g, '');
        }
      } else if (clean.includes(',')) {
        clean = clean.replace(',', '.');
      }
      const num = Number(clean);
      return isNaN(num) ? 0 : num;
    }
    return 0;
  }

  getMetaCampanha(): number {
    return this.parseMonetaryValue(this.campanha?.metaArrecadar);
  }

  getArrecadadoCampanha(): number {
    return this.parseMonetaryValue(this.campanha?.valorArrecado);
  }

  getValorRestanteCampanha(): number {
    const meta = this.getMetaCampanha();
    const arrecadado = this.getArrecadadoCampanha();
    if (meta <= 0) return 0;
    return Math.max(0, Number((meta - arrecadado).toFixed(2)));
  }

  definirValorApoio(valor: number): void {
    if (this.IsrecompensaCampanha && !this.apoiarSemRecompensa) {
      this.apoiarSemRecompensa = true;
      this.recompensaSelecionada = null;
      this.form.get('valorApoio')?.enable();
    }
    this.form.get('valorApoio')?.setValue(valor);
    this.form.get('valorApoio')?.markAsDirty();
  }

  isValorAtivo(valor: number): boolean {
    return (
      this.parseMonetaryValue(this.form.get('valorApoio')?.value) === valor
    );
  }

  validarValorApoio(
    valor: number,
    exibirToast: boolean = true,
  ): { valido: boolean; motivo?: string } {
    if (!valor || valor <= 0) {
      this.totalDoar = 0;
      this.btn_disabled = true;
      return { valido: false, motivo: 'obrigatorio' };
    }

    const meta = this.getMetaCampanha();
    const valorRestante = this.getValorRestanteCampanha();

    // 1. Meta já atingida
    if (meta > 0 && valorRestante <= 0) {
      this.btn_disabled = true;
      this.totalDoar = 0;
      if (exibirToast) {
        this.toast(
          'warn',
          'Meta já atingida',
          'Esta campanha já atingiu a meta total estabelecida e não necessita de mais contribuições.',
        );
      }
      return { valido: false, motivo: 'meta_atingida' };
    }

    // 2. Valor acima do que falta para a meta
    if (meta > 0 && valorRestante > 0 && valor > valorRestante) {
      this.btn_disabled = true;
      this.totalDoar = 0;
      if (exibirToast) {
        this.toast(
          'warn',
          'Valor acima do que falta para a meta',
          `O valor introduzido excede o montante que falta para a meta (${this.moneyPipe.transform(valorRestante)} Kz). Por favor, introduza até ${this.moneyPipe.transform(valorRestante)} Kz.`,
        );
      }
      return { valido: false, motivo: 'acima_meta_restante' };
    }

    // 3. Valor de doação excessivo em relação ao máximo global configurado (somente se valorMax for > 0)
    if (this.valorMax > 0 && valor > this.valorMax) {
      this.btn_disabled = true;
      this.totalDoar = 0;
      if (exibirToast) {
        this.toast(
          'warn',
          'Valor de doação excessivo',
          `O montante excede o limite máximo permitido (${this.moneyPipe.transform(this.valorMax)} Kz). Entre em contacto com a direcção da FundCube.`,
        );
      }
      return { valido: false, motivo: 'acima_maximo_global' };
    }

    // 4. Saldo em carteira insuficiente
    if (this.useSaldoUser) {
      const saldoDisponivel = this.parseMonetaryValue(this.saldo);
      if (valor > saldoDisponivel) {
        this.btn_disabled = true;
        this.totalDoar = 0;
        if (exibirToast) {
          this.toast(
            'warn',
            'Saldo insuficiente',
            `O valor excede o saldo disponível na sua carteira (${this.moneyPipe.transform(saldoDisponivel)} Kz).`,
          );
        }
        return { valido: false, motivo: 'saldo_insuficiente' };
      }
    }

    // 5. Valor abaixo do mínimo (se configurado e > 0)
    if (this.valorMin > 0 && valor < this.valorMin) {
      this.btn_disabled = true;
      const taxa = this.parseMonetaryValue(this.taxaServico);
      this.totalDoar = Number((valor + (valor * taxa) / 100).toFixed(2));
      if (exibirToast) {
        this.toast(
          'warn',
          'Valor abaixo do mínimo',
          `O valor mínimo permitido para esta campanha é de ${this.moneyPipe.transform(this.valorMin)} Kz.`,
        );
      }
      return { valido: false, motivo: 'abaixo_minimo' };
    }

    // Valor válido
    this.btn_disabled = false;
    const taxa = this.parseMonetaryValue(this.taxaServico);
    this.totalDoar = Number((valor + (valor * taxa) / 100).toFixed(2));
    return { valido: true };
  }

  ngOnInit(): void {
    // this.checkProfileUSer();
    const rawId = this.ativateRouder.snapshot.paramMap.get('id');
    const rawNome = this.ativateRouder.snapshot.paramMap.get('nome');

    let candidateId = rawId;
    if (
      rawNome &&
      (!candidateId || isNaN(Number(candidateId))) &&
      !isNaN(Number(rawNome))
    ) {
      candidateId = rawNome;
    }

    const id = candidateId ? RouteUtils.decryptId(candidateId) : null;
    this.campanhaID = id;
    if (this.campanhaID) {
      this.getCampanhaByID(this.campanhaID);
    }
    this.items = [{ label: 'Financiar Campanha' }];
    this.home = { icon: 'pi pi-home', routerLink: '/' };
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });
    if (!this.authService.isLoggedIn()) {
      this.authRedirectService.setReturnUrl(this.router.url);
    }
    this.initForm();
    this.getUser();
  }

  initForm() {
    this.form = this.fb.group({
      valorApoio: [null, Validators.required],
      metodo: [null, Validators.required],
      telefone: [null, []],
    });

    this.preencherTelefoneSeDisponivel();

    // Valor digitado
    this.form.get('valorApoio')?.valueChanges.subscribe((rawVal: any) => {
      const valor = this.parseMonetaryValue(rawVal);
      if (!valor || valor <= 0) {
        this.totalDoar = 0;
        this.btn_disabled = false;
        return;
      }

      const meta = this.getMetaCampanha();
      const valorRestante = this.getValorRestanteCampanha();

      // Alertas imediatos para valores excessivos ou saldo insuficiente
      if (meta > 0 && valorRestante <= 0) {
        this.validarValorApoio(valor, true);
        return;
      }

      if (meta > 0 && valorRestante > 0 && valor > valorRestante) {
        this.validarValorApoio(valor, true);
        return;
      }

      if (this.valorMax > 0 && valor > this.valorMax) {
        this.validarValorApoio(valor, true);
        return;
      }

      if (this.useSaldoUser) {
        const saldoDisponivel = this.parseMonetaryValue(this.saldo);
        if (valor > saldoDisponivel) {
          this.validarValorApoio(valor, true);
          return;
        }
      }

      // Validação sem toast para não atrapalhar a digitação (calcula totalDoar e verifica se está abaixo do mínimo)
      this.validarValorApoio(valor, false);
    });

    // Método de pagamento
    this.form.get('metodo')?.valueChanges.subscribe((metodo: number) => {
      this.metodo = metodo;

      const telefoneCtrl = this.form.get('telefone');

      if (metodo === 2) {
        telefoneCtrl?.enable();
        telefoneCtrl?.setValidators([
          Validators.required,
          Validators.pattern(/^9\d{8}$/),
        ]);
        this.useSaldoUser = false;
        this.preencherTelefoneSeDisponivel();
      } else if (metodo === 5) {
        this.useSaldoUser = true;

        const valorCtrl = this.form.get('valorApoio');
        const metodoCtrl = this.form.get('metodo');
        const telefoneCtrl = this.form.get('telefone');

        if (this.useSaldoUser) {
          // metodoCtrl?.disable();
          telefoneCtrl?.disable();
        } else {
          metodoCtrl?.enable();
          telefoneCtrl?.enable();
        }

        valorCtrl?.updateValueAndValidity();
      } else {
        telefoneCtrl?.clearValidators();
        this.useSaldoUser = false;
      }

      telefoneCtrl?.updateValueAndValidity();
    });
  }

  loadDropdowns() {
    const tipo =
      this.tipoFinanciamento || this.campanha?.tipoFinanciamentoENUM || 1;

    forkJoin({
      // Enums
      metodoPagamento: this.enumService
        .getAllMetodoPagamento()
        .pipe(catchError(() => of(null))),
      doacaoMim: this.configuracoesService
        .getDoacaoMinima(tipo)
        .pipe(catchError(() => of(0))),
      doacaoMax: this.configuracoesService
        .getDoacaoMaxima(tipo)
        .pipe(catchError(() => of(0))),
      taxaServico: this.configuracoesService
        .getTaxaServico(tipo)
        .pipe(catchError(() => of(0))),
    }).subscribe({
      next: (response) => {
        this.valorMax = this.parseMonetaryValue(response.doacaoMax);
        this.valorMin = this.parseMonetaryValue(response.doacaoMim);
        this.taxaServico = this.parseMonetaryValue(response.taxaServico);

        // Enums
        if (response.metodoPagamento?.data) {
          this.metodoPaymentList = Object.entries(
            response.metodoPagamento.data,
          ).map(([key, value]) => ({
            id: Number(key),
            label: value as string,
          }));
        }

        const valorAtual = this.parseMonetaryValue(
          this.form.get('valorApoio')?.value,
        );
        if (valorAtual > 0) {
          this.validarValorApoio(valorAtual, false);
        }
      },
      error: (err) => {
        console.error('Erro ao carregar configurações de doação:', err);
      },
    });
  }

  getCampanhaByID(id: string) {
    this.campanhaService.show(id).subscribe({
      next: (res) => {
        this.campanha = res.data;
        if (this.campanha?.expirado) {
          this.messageService.add({
            severity: 'info',
            summary: 'Esta campanha não pode receber doações',
            detail: 'Campanha expirada, apenas pode ver os detalhes.',
          });

          setTimeout(() => {
            this.router.navigate(['/detalhe-campanha/', id]);
          }, 3500);
        }

        const meta = this.getMetaCampanha();
        const arrecadado = this.getArrecadadoCampanha();
        if (meta > 0 && arrecadado >= meta) {
          this.toast(
            'info',
            'Meta da campanha atingida',
            'Esta campanha já atingiu a meta total estabelecida.',
          );
        }

        this.tipoFinanciamento = this.campanha?.tipoFinanciamentoENUM || 1;
        if (
          this.campanha?.tipoFinanciamentoENUM === 3 ||
          String(this.campanha?.tipoFinanciamento).toLowerCase() === 'recompensa' ||
          (Array.isArray(this.campanha?.recompensa) && this.campanha.recompensa.length > 0)
        ) {
          this.IsrecompensaCampanha = true;
          this.form.get('valorApoio')?.disable();

          // Auto-selecionar recompensa indicada no queryParam ou a primeira da lista
          const queryRecId = this.ativateRouder.snapshot.queryParamMap.get('recompensaId');
          if (Array.isArray(this.campanha?.recompensa) && this.campanha.recompensa.length > 0) {
            let toSelect = this.campanha.recompensa[0];
            if (queryRecId) {
              const match = this.campanha.recompensa.find(
                (r: any) => String(r.id) === String(queryRecId),
              );
              if (match) toSelect = match;
            }
            this.selecionarRecompensa(toSelect);
          }
        } else {
          this.IsrecompensaCampanha = false;
          this.form.get('valorApoio')?.enable();
        }
        const fotoAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
        );
        this.loadDropdowns();
        if (fotoAnexo?.anexo?.id) {
          this.getPhotoCampanha(fotoAnexo.anexo.id);
        }
        this.getUser();
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  submitPayment() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toast(
        'error',
        'Formulário inválido',
        'Por favor, verifique os campos obrigatórios preenchidos.',
      );
      return;
    }

    if (this.IsrecompensaCampanha && !this.apoiarSemRecompensa && !this.recompensaSelecionada) {
      this.toast(
        'warn',
        'Recompensa não selecionada',
        'Por favor, selecione uma recompensa ou opte pelo Apoio de Livre Vontade.',
      );
      return;
    }

    if (!this.IsAuthenticad) {
      this.btn_disabled = true;
      this.toast(
        'warn',
        'Autenticação necessária',
        'Por favor, crie uma conta ou inicie sessão para concluir o financiamento.',
      );
      const returnUrl = this.router.url;
      setTimeout(() => {
        this.authRedirectService.redirectToRegister(returnUrl);
      }, 800);
      return;
    }

    if (this.IsrecompensaCampanha && !this.apoiarSemRecompensa) {
      this.form.get('valorApoio')?.setValue(Number(this.recompensaSelecionada?.valor) || 0);
    }

    const valorDigitado = (this.IsrecompensaCampanha && !this.apoiarSemRecompensa)
      ? Number(this.recompensaSelecionada?.valor) || 0
      : this.parseMonetaryValue(this.form.get('valorApoio')?.value);

    if ((!this.IsrecompensaCampanha || this.apoiarSemRecompensa) && (!valorDigitado || valorDigitado <= 0)) {
      this.toast(
        'warn',
        'Valor obrigatório',
        'Informe o valor da contribuição.',
      );
      return;
    }

    if (!this.IsrecompensaCampanha || this.apoiarSemRecompensa) {
      const validacao = this.validarValorApoio(valorDigitado, true);
      if (!validacao.valido) {
        return;
      }
    }

    if (this.useSaldoUser) {
      const saldoDisponivel = this.parseMonetaryValue(this.saldo);
      if (saldoDisponivel < valorDigitado) {
        this.toast(
          'error',
          'Saldo insuficiente',
          'O seu saldo não é suficiente para esta contribuição.',
        );
        return;
      }
    }

    const taxa = this.parseMonetaryValue(this.taxaServico);
    const valorFinal = this.useSaldoUser
      ? valorDigitado
      : Number((valorDigitado + (valorDigitado * taxa) / 100).toFixed(2));

    this.loading = true;
    this.btn_disabled = true;
    this.form.get('valorApoio')?.disable();

    const payload: any = {
      id: 0,
      campanhaID: this.campanha?.id,
      utilizadorID: this.userService.getUserId(),
      emailUtilizador: this.utilizador?.email,
      recompensaID: (!this.IsrecompensaCampanha || this.apoiarSemRecompensa) ? 0 : (this.recompensaSelecionada?.id || 0),
      valorApoio: valorFinal,
      estadoApoioENUM: 1,
      metodoPagamentoENUM: this.form.get('metodo')?.value || 1,
      termoEmprestimoID: this.campanha?.termosEmprestimo?.id || 0,
      isUtilizarSaldo: this.useSaldoUser,
      telefone:
        this.metodo === 2 ? this.form.get('telefone')?.value : undefined,
    };

    this.apoioService.store(payload).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.form.get('valorApoio')?.enable();

        if (res?.retorno?.codigo === 200) {
          this.resposta = res.data;
          this.showResposta = this.metodo === 1;

          const msgSucesso = getResponseMessage(
            res,
            this.metodo === 1
              ? 'Pode fazer o pagamento pela referência e entidade fornecidas.'
              : 'Verifique o seu Multicaixa Express para confirmar o pagamento.'
          );

          this.toast(
            'success',
            this.metodo === 1
              ? 'Referência gerada com sucesso'
              : 'Pagamento enviado com sucesso',
            msgSucesso,
          );

          this.form.reset();
          this.recompensaSelecionada = null;
          return;
        }

        this.btn_disabled = false;
        const msgAviso = getResponseMessage(
          res,
          'Não foi possível processar a contribuição.'
        );

        this.toast(
          'warn',
          'Não foi possível concluir a operação',
          msgAviso,
        );

        setTimeout(() => this.form.reset(), 5500);
      },

      error: (err) => {
        this.loading = false;
        this.btn_disabled = false;
        this.form.get('valorApoio')?.enable();
        console.error('Erro na submissão do apoio:', err);

        const msgErro = getResponseMessage(
          err,
          'Ocorreu um erro no servidor ao tentar processar o pagamento. Por favor, tente novamente mais tarde.'
        );

        this.toast('error', 'Não foi possível concluir', msgErro);
      },
    });
  }

  // Helper para evitar repetição
  private toast(severity: string, summary: string, detail: string) {
    this.messageService.add({ severity, summary, detail, life: 5000 });
  }

  getPhotoCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);
        this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob),
        ) as any;
        this.imgInfo = {
          nome: `Imagem_${id}.jpg`,
          tamanho: `${(blob.size / 1024).toFixed(2)} KB`,
          tipo: blob.type || 'image/jpeg',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPercent(campanha: any): number {
    const meta = this.parseMonetaryValue(campanha?.metaArrecadar);
    const arrecadado = this.parseMonetaryValue(campanha?.valorArrecado);
    if (!meta || meta <= 0) return 0;
    return Math.min(Math.max(Math.round((arrecadado / meta) * 100), 0), 100);
  }

  isInvalid(field: string): boolean {
    const control = this.form.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getSaldoUser(): void {
    if (this.utilizador) {
      this.apoioService.consultarSaldoUser(this.utilizador.id).subscribe({
        next: (res) => {
          this.saldo = res.data;
        },
        error: (err) => {
          console.error(err);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro ao consultar saldo',
            detail: 'Não foi possível obter o saldo do usuário.',
            life: 5000,
          });
        },
      });
    }
  }

  getUser(): void {
    if (this.utilizador) {
      this.preencherTelefoneSeDisponivel();
      return;
    }
    const userId = this.userService.getUserId();
    if (userId) {
      this.utilizadoresService.show(userId).subscribe({
        next: (res) => {
          this.utilizador = res.data;
          this.saldo = this.utilizador?.saldo;
          this.preencherTelefoneSeDisponivel();
        },
        error: (err) => {
          console.error(err);
        },
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sem sessão iniciada',
        detail: 'Faça login para continuar',
        life: 5000,
      });
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 4200);
      console.error('User ID is null');
    }
  }

  preencherTelefoneSeDisponivel(): void {
    const telefoneCtrl = this.form?.get('telefone');
    if (!telefoneCtrl) return;

    // Se o utilizador já digitou algo manualmente (dirty) e o campo tem valor, preserva a edição do utilizador
    if (telefoneCtrl.dirty && telefoneCtrl.value) {
      return;
    }

    const rawPhone =
      this.utilizador?.telefone || this.userService.getUserPhone();
    if (rawPhone) {
      const formatted = this.formatUserPhone(rawPhone);
      if (formatted) {
        telefoneCtrl.setValue(formatted);
      }
    }
  }

  formatUserPhone(phoneInput: any): number | null {
    if (phoneInput === null || phoneInput === undefined) return null;
    const cleanDigits = String(phoneInput).replace(/\D/g, '');
    if (!cleanDigits) return null;

    let targetDigits = cleanDigits;
    if (targetDigits.length === 11 && targetDigits.startsWith('244')) {
      targetDigits = targetDigits.slice(2);
    } else if (targetDigits.length > 9 && targetDigits.startsWith('244')) {
      targetDigits = targetDigits.slice(2);
    } else if (targetDigits.length > 9) {
      targetDigits = targetDigits.slice(-9);
    }

    const num = Number(targetDigits);
    return isNaN(num) ? null : num;
  }

  checkProfileUSer() {
    this.utilizadoresService
      .checkPerfilUser(this.userService.getUserId() || '')
      .subscribe({
        next: (res: any) => {
          if (res?.retorno.codigo === 200) {
            this.IsprofileComplet = res?.data;

            if (!this.IsprofileComplet) {
              this.router.navigate(['/']);
            }
          } else {
            this.IsprofileComplet = false;
          }
        },
      });
  }

  ativarModoComRecompensa(): void {
    this.apoiarSemRecompensa = false;
    if (!this.recompensaSelecionada && Array.isArray(this.campanha?.recompensa) && this.campanha.recompensa.length > 0) {
      this.selecionarRecompensa(this.campanha.recompensa[0]);
    } else if (this.recompensaSelecionada) {
      this.form.get('valorApoio')?.setValue(this.recompensaSelecionada.valor);
      this.form.get('valorApoio')?.disable();
    }
  }

  escolherApoioSemRecompensa(): void {
    this.apoiarSemRecompensa = true;
    this.recompensaSelecionada = null;
    this.form.get('valorApoio')?.enable();
    const valAtual = this.form.get('valorApoio')?.value;
    if (!valAtual || valAtual <= 0) {
      this.definirValorApoio(5000);
    }
  }

  selecionarRecompensa(recompensa: any) {
    this.apoiarSemRecompensa = false;
    this.recompensaSelecionada = recompensa;
    this.form.get('valorApoio')?.setValue(recompensa.valor);
    this.form.get('valorApoio')?.disable();
  }

  selectMetodo(id: number) {
    this.form.get('metodo')?.setValue(id);
    this.form.get('metodo')?.markAsDirty();
  }

  copyToClipboard(text: string) {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      this.toast(
        'info',
        'Copiado',
        'Texto copiado para a área de transferência.',
      );
    });
  }

  irParaRegisto(): void {
    this.authRedirectService.redirectToRegister(this.router.url);
  }

  irParaLogin(): void {
    this.authRedirectService.redirectToLogin(this.router.url);
  }
}
